import DashboardLayout from "src/layouts/DashboardLayout";
import useEmbeddedDocusign from "src/hooks/useEmbeddedDocusign";
import { Alert, Spinner } from "@porchpass/ui";
import { StyledLink } from "src/components/common";
import { useParams } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "src/context";

export default () => {
  const { errorMessage, docusignLoading } = useEmbeddedDocusign();
  const { dealerName } = useParams();
  const { userData } = useContext(UserContext);
  const applicationId = userData?.application_id;

  return (
    <DashboardLayout pageTitle="Docusign Signature">
      {errorMessage ? (
        <div className="mx-5 flex flex-col items-center gap-5">
          <Alert variant="error">{errorMessage}</Alert>
          <StyledLink
            to={`/${dealerName}/application/${applicationId}/progress`}
          >
            Return to Progress Page
          </StyledLink>
        </div>
      ) : (
        <div className="relative flex h-[90vh] w-full items-center justify-center bg-[rgb(243,244,247)]">
          {docusignLoading && (
            <div className="absolute mt-[60px] flex min-h-[110px] flex-col items-center gap-4 p-5">
              <p className="mt-auto text-center">
                Please wait while we prepare your documents for signing...
              </p>
            </div>
          )}
          <div className="h-full w-full" id="docusign">
            <div className="flex h-full flex-col items-center justify-center gap-4 p-5">
              <Spinner size="l" />
            </div>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
};
